import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	emptyContainer: {
		display        : "flex",
		alignItems     : "center",
		justifyContent : "center",
		margin         : "3rem 0"
		// background     : `${ theme.other.colors.background.primary } !important`
	},
	textContainer: {
		textAlign     : "center",
		display       : "flex",
		flexDirection : "column",
		alignItems    : "center",
		gap           : "1rem"
	},
	iconStyle: {
		width  : theme.other.isMobile ? "150px" : "200px",
		height : "auto"
	}
} ) );
